var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "slider-arrow-sl",
  "use": "slider-arrow-sl-usage",
  "viewBox": "0 0 10 20",
  "content": "<symbol viewBox=\"0 0 10 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"slider-arrow-sl\">\n    <path d=\"M9.333 18.778a.75.75 0 0 1-1.09 1.025l-.076-.08-7.5-9.25a.75.75 0 0 1-.066-.85l.066-.095 7.5-9.25a.75.75 0 0 1 1.229.853l-.063.091L2.216 10l7.117 8.778z\" fill=\"#000\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id